import React, { useState } from "react";
import {
  Button as MuiButton,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Tooltip,
  makeStyles,
} from "@material-ui/core";
import { Button as RaButton } from "react-admin";
import FormatListBulletedIcon from "@material-ui/icons/FormatListBulleted";
import StudentSubsidyHistoryTable from "../../studentSubsidies/components/StudentSubsidyHistoryTable";

interface IShowStudentSubsidyHistoryButton {
  studentId: number;
  activeStudentSubsidyId: number;
}

const useStyles = makeStyles({
  dialog: {
    "& .MuiDialog-paper": {
      overflowY: "unset",
    },
  },
  cancelButton: {
    backgroundColor: "#eeeeee",
    color: "black",
  },
  smallButton: {
    minWidth: "32px",
    padding: "6px",
    backgroundColor: "#eeeeee",
    color: "black",
  },
});

const ShowStudentSubsidyHistoryButton = ({
  studentId,
  activeStudentSubsidyId,
}: IShowStudentSubsidyHistoryButton) => {
  const [open, setOpen] = useState<boolean>(false);

  const classes = useStyles();

  const handleOpenDialog = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <>
      <Tooltip title="Show Student Subsidy History">
        <MuiButton
          size="small"
          className={classes.smallButton}
          onClick={handleOpenDialog}
        >
          <FormatListBulletedIcon fontSize="small" />
        </MuiButton>
      </Tooltip>

      <Dialog
        open={open}
        aria-labelledby="show-history-dialog-title"
        aria-describedby="show-history-dialog-description"
        className={classes.dialog}
        maxWidth="md"
      >
        <DialogTitle id="show-history-dialog-title">
          Student Subsidy History
        </DialogTitle>
        <DialogContent>
          <StudentSubsidyHistoryTable
            studentId={studentId}
            activeStudentSubsidyId={activeStudentSubsidyId}
          />
        </DialogContent>
        <DialogActions>
          <RaButton
            label="Back"
            color="secondary"
            onClick={handleClose}
            className={classes.cancelButton}
          />
        </DialogActions>
      </Dialog>
    </>
  );
};

export default ShowStudentSubsidyHistoryButton;
